<template>
  <section class="container">
    <stockTopMenu curPosition="业绩日历" windowId="performanceCalendar" module="yejicalendar"></stockTopMenu>
    <main class="main-content"
      v-loading="fetchLoading"
      element-loading-text="全力加载中，请稍等...">
      <div class="row align-center space-between top-row" v-if="isRevenue === 'N'">
        <div class="row align-center top-row-left">
          <div :class="[viewType === '1' ? 'active-div' : '']" @click="changeViewType('1')">店铺</div>
          <div :class="[viewType === '2' ? 'active-div' : '']" @click="changeViewType('2')">店员</div>
        </div>
        <div class="row align-center top-row-right">
          <div @click="expressVisible = true">查看历练公单业绩</div>
          <div @click="teamVisible = true">查看公单业绩</div>
        </div>
      </div>
      <div class="row align-center space-between other-row">
        <div class="other-row-left">
          <span>业绩数据</span>
          <span v-if="isRevenue === 'N'">按住键盘shift键的同时操作鼠标滚轮可以左右滑动</span>
        </div>
        <div class="row align-center other-row-right">
          <div class="row align-center other-row-select" v-if="viewType === '2'">
            <el-select
              multiple
              clearable
              filterable
              size="small"
              collapse-tags
              v-model="selectIds"
              placeholder="选择营业员"
              style="width: 260px;">
              <el-option
                v-for="item in selectUserList"
                :key="item.id"
                :value="item.id"
                :label="item.realName">
              </el-option>
            </el-select>
            <div class="sure-btn" @click="sureQuery">确 定</div>
          </div>
          <div class="row align-center month-div">
            <div :class="[monthType === '1' ? 'active-month' : '']" @click="changeMonth('1')">本月</div>
            <div :class="[monthType === '2' ? 'active-month' : '']" @click="changeMonth('2')">上月</div>
          </div>
        </div>
      </div>

      <el-table
        border
        stripe
        size="small"
        ref="myTable"
        height="81vh"
        show-summary
        row-key="id"
        v-if="isRevenue === 'N'"
        :data="tableData"
        :summary-method="getSummaries"
        :header-cell-style="{
          color: '#666',
          padding: '6px 0',
          background: '#f0f0f0'
        }"
        :cell-style="{
          color: '#333',
          padding: '6px 0'
        }">
        <template v-if="viewType === '2'">
          <el-table-column key="col_user_name" prop="user_name" label="姓名" fixed="left" align="center" width="150" :resizable="false"></el-table-column>
          <el-table-column key="col_post_name" prop="post_name" label="职级" fixed="left" align="center" width="120" :resizable="false"></el-table-column>
        </template>
        <el-table-column key="col_calculate_date" prop="calculate_date" label="日期" fixed="left" align="center" width="150" :resizable="false"></el-table-column>
        <el-table-column key="col_sale_amount" prop="sale_amount" label="总业绩" fixed="left" align="center" width="120" :resizable="false" :render-header="renderAgeHeader">
          <template slot-scope="scope">
            <template v-if="Number(scope.row['sale_amount']) > 0">
              <div v-if="viewType === '2'" :class="['custom-cell', scope.row['post_type'] !== 2 && Number(scope.row['sale_amount']) >= Number(scope.row['tz_mb']) ? 'cell-red' : '']">￥{{scope.row['sale_amount']}}</div>
              <div v-else :class="['custom-cell', (Number(scope.row['jc_mb']) <= Number(scope.row['sale_amount']) && Number(scope.row['sale_amount']) < Number(scope.row['tz_mb'])) ? 'cell-green' : Number(scope.row['sale_amount']) >= Number(scope.row['tz_mb']) ? 'cell-red' : '']">￥{{scope.row['sale_amount']}}</div>
            </template>
          </template>
        </el-table-column>
        
        <el-table-column key="col_gd_amt" prop="gd_amt" label="公单" :fixed="viewType === '1' ? undefined : 'left'" align="center" width="120" :resizable="false" :formatter="cellFormatter" :render-header="renderAgeHeader"></el-table-column>
          <template v-if="viewType === '2'">
          <el-table-column key="col_llgd_amt" prop="llgd_amt" label="历练公单业绩" fixed="left" align="center" width="120" :resizable="false" :formatter="cellFormatter"></el-table-column>
        </template>
        <template v-if="viewType === '1'">
          <el-table-column key="col_recharge_amount" prop="recharge_amount" label="会员充值" align="center" width="120" :resizable="false" :formatter="cellFormatter"></el-table-column>
        </template>
        <el-table-column key="col_tz_mb" prop="tz_mb" :label="viewType === '1' ? '挑战目标' : '目标'" align="center" width="120" :resizable="false" :formatter="cellFormatter"></el-table-column>
        <el-table-column key="col_challengeCompletionRate" prop="challengeCompletionRate" label="完成率" align="center" width="120" :resizable="false" :formatter="cellFormatter"></el-table-column>
        <el-table-column key="col_effective_sale_count" prop="effective_sale_count" label="单数" align="center" width="120" :resizable="false" :formatter="cellFormatter" :render-header="renderAgeHeader"></el-table-column>
        <el-table-column key="col_effective_sale_num" prop="effective_sale_num" label="件数" align="center" width="120" :resizable="false" :formatter="cellFormatter" :render-header="renderAgeHeader"></el-table-column>
        <el-table-column key="col_averageOrderValue" prop="averageOrderValue" label="客单价" align="center" width="120" :resizable="false" :formatter="cellFormatter" :render-header="renderAgeHeader"></el-table-column>
        <el-table-column key="col_unitPrice" prop="unitPrice" label="件单价" align="center" width="120" :resizable="false" :formatter="cellFormatter" :render-header="renderAgeHeader"></el-table-column>
        <el-table-column key="col_attachmentRate" prop="attachmentRate" label="连带率" align="center" width="120" :resizable="false" :formatter="cellFormatter" :render-header="renderAgeHeader"></el-table-column>

        <template v-for="(item, index) in payColumns">
          <el-table-column :key="index" :prop="item['pay_type']" :label="item['label']" :width="item['width']" align="center"  :resizable="false" :formatter="cellFormatter"></el-table-column>
        </template>
      </el-table>

      <el-table
        border
        stripe
        v-else
        size="small"
        ref="myTable"
        height="86vh"
        show-summary
        row-key="id"
        :data="tableData"
        :summary-method="getSummaries"
        :header-cell-style="{
          color: '#333',
          padding: '6px 0',
          background: '#f0f0f0'
        }"
        :cell-style="{
          color: '#333',
          padding: '6px 0'
        }">
        <el-table-column prop="calculate_date" label="日期" align="center" :resizable="false"></el-table-column>
        <el-table-column prop="sale_amount" label="总业绩" align="center" :resizable="false">
          <template slot-scope="scope">
            <div v-if="Number(scope.row['sale_amount']) > 0" :class="['custom-cell', (Number(scope.row['jc_mb']) <= Number(scope.row['sale_amount']) && Number(scope.row['sale_amount']) < Number(scope.row['tz_mb'])) ? 'cell-green' : Number(scope.row['sale_amount']) >= Number(scope.row['tz_mb']) ? 'cell-red' : '']">￥{{scope.row['sale_amount']}}</div>
          </template>
        </el-table-column>
      </el-table>
    </main>
    <TeamSales v-if="teamVisible" @close="teamVisible = false"></TeamSales>
    <Express v-if="expressVisible" @close="expressVisible = false"></Express>
  </section>
</template>

<script>
import moment from "moment"
import tool from "@/utils/tool.js"
import TeamSales from "./components/teamSales"
import Express from "./components/expreience.vue"
import stockTopMenu from "@/components/stockTopMenu.vue"
import newPostUrl from "@/libs/http/modules/oa.js"
export default {
  components: {
    Express,
    TeamSales,
    stockTopMenu
  },
  data() {
    return{
      viewType: '1',
      monthType: '1',
      selectIds: [],
      teamVisible: false,
      fetchLoading: false,
      expressVisible: false,
      selectUserList: [],
      tableData: [],
      payColumns: [],
      totalRowObj: {},
      headerTooltips: {
        effective_sale_count: '不含销售价格低于50元的配饰，退单，换单',
        effective_sale_num: '不含销售价格低于50元的配饰，退单，换单',
        averageOrderValue: '客单价=成交金额÷成交单数\n不含销售价格低于50元的配饰，退单，换单',
        unitPrice: '件单价=成交金额÷成交件数\n不含销售价格低于50元的配饰，退单，换单',
        attachmentRate: '连带率=成交件数 ÷ 成交单数\n不含销售价格低于50元的配饰，退单，换单',
        sale_amount: '',
        gd_amt: '此业绩为店铺总公单业绩'
      },
      isRevenue: this.$cache.local.get('isRevenue'),
    }
  },
  updated() {
    this.$nextTick(() => {
      this.$refs.myTable ?. doLayout()
    })
  },
  mounted() {
    let tokenTime = tool.data.get('TOKEN_TIME')
    if(tool.data.get('TOKEN') && !this.hasExceededThirtyMinutes(tokenTime)){
      this.fetchData()
      this.queryPayColumns()
    }else{
      const newRequest = async () => {
        try {
          const result = await newPostUrl.newLogin()
          if (result) {
            this.fetchData()
            this.queryPayColumns()
          }
        } catch (error) {
          this.$message({ type: 'error', message: error.msg || error, duration: 2000, showClose: true })
        }
      }
      newRequest()
    }
  },
  methods: {
    hasExceededThirtyMinutes(tokenTime) {
      if(!tokenTime){
        return true
      }
      const THIRTY_MINUTES_MS = 30 * 60 * 1000 // 30分钟的毫秒数
      const currentTimestamp = Date.now() // 当前时间戳
      const timeDifference = currentTimestamp - tokenTime // 计算时间差
      return timeDifference >= THIRTY_MINUTES_MS // 判断是否超过30分钟
    },
    changeViewType(type){
      if(this.viewType !== type){
        this.selectIds = []
        this.viewType = type
        this.fetchData()
      }
    },
    changeMonth(type){
      if(this.monthType !== type){
        this.monthType = type
        this.fetchData()
      }
    },
    queryPayColumns(){
      newPostUrl.lessCodeSqlQuery({
        pagination: false,
        datasetCode: 'a477cd8814284b23b517ac72df94c51c'
      }).then(res=>{
        this.payColumns = res.items || []
      }).catch(error=>{})
    },
    fetchData(){
      this.fetchLoading = true
      const params = {
        page: '1',
        pageSize: '1000'
      }
      if(this.isRevenue === 'N'){
        if(this.viewType === '1'){
          params['datasetCode'] = 'b71c1a8471604679a5fb376ef2153617'
        }else{
          params['datasetCode'] = 'dbd31e86a91d4cdbb6e9818f19a36ead'
        }
      }else{
        params['datasetCode'] = '15c1a60a673c4a17882a765c8f981782'
      }
      const conditionList = [
        {key: 'marketId', valueList: [this.$cache.local.get('marketingUnitId')]},
        {key: 'startDate', valueList: [moment().startOf('month').format('YYYY-MM-DD')]},
        {key: 'endDate', valueList: [moment().endOf('month').format('YYYY-MM-DD')]}
      ]
      if(this.monthType === '1'){
        conditionList[1].valueList = [moment().startOf('month').format('YYYY-MM-DD')]
        conditionList[2].valueList = [moment().endOf('month').format('YYYY-MM-DD')]
      }else{
        conditionList[1].valueList = [moment(new Date()).subtract(1,'months').startOf('month').format('YYYY-MM-DD')]
        conditionList[2].valueList = [moment(new Date()).subtract(1,'months').endOf('month').format('YYYY-MM-DD')]
      }
      if(this.viewType === '2' && this.selectIds.length){
        conditionList[3] = {
          key: 'userIds',
          valueList: this.selectIds
        }
      }
      params['conditionList'] = conditionList
      newPostUrl.lessCodeSqlQuery(params).then(res=>{
        this.tableData = res.items || []
        // 获取营业员列表
        if(this.viewType === '2'){
          const list = res.items.map(item=>{
            return {
              realName: item['user_name'],
              id: item['user_id'].toString()
            }
          })
          this.queryUserList(list)
        }
        // 查询汇总信息
        let totalCode = ''
        if(this.isRevenue === 'N'){
          if(this.viewType === '1'){
            totalCode = 'f597d59aecb54ef4805ad7206e033e25'
          }else{
            totalCode = 'cd4afe90c4884b88ae9fb422650a186a'
          }
        }else{
          totalCode = '420d2d233eb6421cac3d1c63a8330175'
        }
        this.queryDataTotal(totalCode, conditionList)
      }).catch(err=>{
        this.tableData = []
        this.fetchLoading = false
      })
    },
    queryUserList(list){
      let userList = []
      newPostUrl.salespersonInfoList({id: this.$cache.local.get('marketingUnitId')}).then(res=>{
        if(res['oaSalespersonInfo']){
          if(res['oaSalespersonInfo']['shopSalespersonInfoList'] && res['oaSalespersonInfo']['shopSalespersonInfoList'].length){
            userList = [...userList, ...res['oaSalespersonInfo']['shopSalespersonInfoList']]
          }
          if(res['oaSalespersonInfo']['otherSalespersonInfoList'] && res['oaSalespersonInfo']['otherSalespersonInfoList'].length){
            userList = [...userList, ...res['oaSalespersonInfo']['otherSalespersonInfoList']]
          }
        }
        if(res.directorInfoList ?. length){
          userList = [...userList, ...res.directorInfoList]
        }
        if(res.otherDirectorInfoList ?. length){
          userList = [...userList, ...res.otherDirectorInfoList]
        }
        const allList = [...list, ...userList]
        this.selectUserList = [...new Map(allList.map(item => [item.id, item])).values()]
      }).catch((error)=>{})
    },
    sureQuery(){
      this.fetchData()
    },
    queryDataTotal(code, conditionList){
      newPostUrl.lessCodeSqlQuery({
        datasetCode: code,
        conditionList: conditionList
      }).then(res=>{
        this.fetchLoading = false
        this.totalRowObj = res.items && res.items.length ? res.items[0] : {}
      }).catch(error=>{
        this.fetchLoading = false
      })
    },
    renderAgeHeader(h, { column }){
      return h('div', [
        h('span', column.label),
        h('el-tooltip', {
          props: {
            placement: 'top',
            content: (() => {
              if(column.property !== 'sale_amount'){
                return this.headerTooltips[column.property]
              }else{
                return this.viewType === '1' ? '店铺业绩和店铺公单业绩' : '不含公单'
              }
            })()
          }
        }, [
          h('i', {
            class: 'el-icon-question',
            style: {
              color: '#999',
              marginLeft: '5px',
              cursor: 'pointer',
            }
          })
        ])
      ])
    },
    cellFormatter(row, column, cellValue){
      const specialFields = [
        'challengeCompletionRate',
        'effective_sale_count',
        'effective_sale_num',
        'attachmentRate'
      ]
      if(['0.00%', '0', 0, '', undefined, null].includes(cellValue)){
        return  ''
      }else{
        if(specialFields.includes(column.property)){
          return cellValue
        }else{
          return '￥' + Number(cellValue)
        }
      }
    },
    getSummaries(param){
      const { columns } = param
      const sums = new Array(columns.length).fill('')
      const rateFields = [
        'challengeCompletionRate',
        'effective_sale_count',
        'effective_sale_num',
        'attachmentRate'
      ]
      const renderCell = (prop) => {
        const val = this.totalRowObj[prop]
        if(rateFields.includes(prop)){
          return ['0.00%', '0', 0, '', undefined, null].includes(val) ? '' : val
        }
        if(val){
          return '￥' + Number(val)
        }
        return ''
      }
      if(this.isRevenue === 'N'){
        if(this.viewType === '1'){
          columns.forEach((col, index) => {
            if(index === 0){
              sums[index] = '月汇总'
            }else{
              sums[index] = renderCell(col.property)
            }
          })
        }else{
          columns.forEach((col, index) => {
            if(index === 2){
              sums[index] = '汇总'
            }else if(index > 2){
              sums[index] = renderCell(col.property)
            }
          })
        }
      }else{
        columns.forEach((col, index) => {
          if(index === 0){
            sums[index] = '月汇总'
          }else{
            sums[index] = renderCell(col.property)
          }
        })
      }
      return sums
    }
  }
}
</script>

<style lang="scss" scoped>
.main-content{
  height: 92vh;
  margin: 10px;
  padding: 10px;
  background: #fff;
  .top-row{
    margin-bottom: 20px;
    .top-row-left{
      div{
        color: #666;
        width: 150px;
        padding: 4px 0;
        cursor: pointer;
        font-weight: 600;
        text-align: center;
        border: 1px solid #eee;
        &:first-child{
          border-radius: 2px 0 0 2px;
        }
        &:last-child{
          border-radius: 0 2px 2px 0;
        }
      }
      .active-div{
        color: #fff;
        background: #02A7F0;
        border: 1px solid #02A7F0;
      }
    }
    .top-row-right{
      div{
        color: #02A7F0;
        cursor: pointer;
        padding: 4px 10px;
        margin-left: 10px;
        border-radius: 2px;
        border: 1px solid #02A7F0;
      }
    }
  }
  .other-row{
    margin-bottom: 10px;
    .other-row-left{
      span{
        &:last-child{
          color: #02A7F0;
          font-size: 14px;
          font-weight: bold;
          margin-left: 20px;
        }
      }
    }
    .other-row-right{
      .other-row-select{
        margin-right: 50px;
        .sure-btn{
          width: 80px;
          color: #fff;
          cursor: pointer;
          line-height: 30px;
          margin-left: 10px;
          text-align: center;
          border-radius: 4px;
          background: #02A7F0;
        }
      }
      .month-div{
        margin-left: 20px;
        div{
          width: 80px;
          color: #666;
          cursor: pointer;
          line-height: 30px;
          text-align: center;
          border: 1px solid #eee;
          &:first-child{
            border-radius: 2px 0 0 2px;
          }
          &:last-child{
            border-radius: 0 2px 2px 0;
          }
        }
        .active-month{
          color: #fff;
          background: #02A7F0;
          border: 1px solid #02A7F0;
        }
      }
    }
  }
  .custom-cell{
    width: 100px;
    height: 26px;
    margin: auto;
    line-height: 26px;
    border-radius: 4px;
  }
  .cell-green{
    color: #fff;
    background: #46CD7B;
  }
  .cell-red{
    color: #fff;
    background: #F99898;
  }
}
</style>
<style>
.main-content .el-tooltip__popper, .is-dark{
  padding: 5px;
  line-height: 20px;
  white-space: pre-line;
}
.main-content .el-table--mini, .el-table--small, .el-table__expand-icon{
  font-size: 14px;
}
</style>